RivalIQ.module('export.collections', function (collections, App, Backbone, Marionette, $, _) {

    'use strict';

    collections.ReportSchedules = Backbone.Collection.extend({
        model: RivalIQ.export.models.ReportSchedule,
        url: '/api/reportSchedule'
    });
});
